import { useState } from 'react'
import Image from 'next/image'
import useSWRInfinite from 'swr/infinite'
import internalApiQueryWrapper from '../../network/internalApiQueryWrapper'
import { STORIES_PER_PAGE } from '../../utils/constants'
import loadMore from '../../utils/loadMore'
import Metadata from '../Metadata'
import SolidLine from '../SolidLine'
import StoryCollection from '../StoryCollection/StoryCollection'
import style from '../../styles/components/category/category'

const CategoryDetails = ({ category: { title, thumbnail, description, id, heroImage }, collection }) => {
  const [storyCollection, setStoryCollection] = useState([collection])
  const [skip, setSkip] = useState(STORIES_PER_PAGE)

  const { data, error, isLoading } = useSWRInfinite(
    () => ({
      url: `/api/collection`,
      args: { skip, ...(id && { categoryId: id }) }
    }),
    internalApiQueryWrapper
  )

  return (
    <>
      <Metadata metadata={{ title: `Cheddar News - ${title}`, thumbnail, description }} />
      {heroImage && <Image src={heroImage.url} width={heroImage.width} height={heroImage.height} alt={title} />}
      <div className='container'>
        <div className='category-container'>
          <div className='category-header'>
            <div className='category-title'>{title}</div>
            {description && <div className='category-description'>{description}</div>}
            <SolidLine />
          </div>
          <StoryCollection
            collection={storyCollection}
            loadMore={() => loadMore({ data, setStoryCollection, setSkip })}
            isLoading={isLoading}
            hideButton={storyCollection[storyCollection.length - 1].length < STORIES_PER_PAGE || error}
          />
        </div>
      </div>
      <style jsx>{style}</style>
    </>
  )
}

export default CategoryDetails
